export const PrivacyPolicyPage = () => {
  return (
    <div className="mx-auto max-w-5xl space-y-10 px-6 pb-20 pt-16 md:px-10">

      {/* HEADER */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Legal
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          Privacy Policy
        </h1>

        <p className="mt-5 text-[#D9E1E8]/80">
          The AI Matters is committed to protecting the privacy of our
          customers, partners, and candidates who interact with our
          platform. This Privacy Policy explains how we collect, use,
          and safeguard information shared through our services.
        </p>
      </section>


      {/* INFORMATION WE COLLECT */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Information We Collect
        </h2>

        <p className="text-[#D9E1E8]/80">
          We may collect information provided directly by users when they
          interact with our platform, including contact information,
          professional details, and hiring-related data. This information
          may include names, email addresses, company information, and
          candidate profile details.
        </p>
      </section>


      {/* HOW WE USE DATA */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          How We Use Information
        </h2>

        <p className="text-[#D9E1E8]/80">
          Information collected through The AI Matters platform is used to
          deliver hiring solutions, improve candidate matching, enhance
          recruiter collaboration, and provide analytics that help
          organizations make better hiring decisions.
        </p>
      </section>


      {/* DATA SECURITY */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Data Security
        </h2>

        <p className="text-[#D9E1E8]/80">
          We implement appropriate technical and organizational measures
          designed to protect personal and business information against
          unauthorized access, alteration, disclosure, or destruction.
        </p>
      </section>


      {/* COOKIES */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Cookies & Tracking Technologies
        </h2>

        <p className="text-[#D9E1E8]/80">
          Our website may use cookies and similar technologies to improve
          user experience, analyze platform usage, and enhance service
          performance.
        </p>
      </section>


      {/* THIRD PARTY SERVICES */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Third-Party Services
        </h2>

        <p className="text-[#D9E1E8]/80">
          In certain cases, we may integrate third-party tools or services
          to support analytics, infrastructure, or platform functionality.
          These services operate under their own privacy policies.
        </p>
      </section>


      {/* CONTACT */}
      <section>
        <h2 className="text-2xl font-semibold mb-3">
          Contact Us
        </h2>

        <p className="text-[#D9E1E8]/80">
          If you have any questions about this Privacy Policy or how
          information is handled on The AI Matters platform, please
          contact us through our official contact page.
        </p>
      </section>

    </div>
  );
};